// extracted by mini-css-extract-plugin
export var content = "_o2-1";
export var fullScreen = "_o2-0";